module.exports = __webpack_public_path__ + "static/upgrades-231abe58191bdbec104d13cc3c47616a.jpg";